import { ProductServiceCard, ProductServiceType } from "@edp-models/energy-efficiency.model";
import { IAppState } from "@edp-store/state/app.state";
import { IEnergyEfficiencyState } from "@edp-store/state/energy-efficiency.state";
import { createSelector } from "@ngrx/store";

const energyEfficiencySelector = (state: IAppState) => state.energyEfficiency;

export const getContractEfficiency = createSelector(
    energyEfficiencySelector,
    (state: IEnergyEfficiencyState) => state.contractEfficiency
);

export const getProductServiceCardData = createSelector(
    energyEfficiencySelector,
    (state: IEnergyEfficiencyState) => state.productServiceCardData
);

export const getContentCardData = createSelector(
    energyEfficiencySelector,
    (state: IEnergyEfficiencyState) => state.contentCardData
);

export const getCo2CardData = createSelector (
    energyEfficiencySelector,
    (state: IEnergyEfficiencyState) => {
        let card: ProductServiceCard;

        if (state.productServiceCardData.length) {
            state.productServiceCardData.forEach(data => {
                card = data.cards.find(card => card.type === ProductServiceType.GREEN_ENERGY);
            });
            return card;
        }
        return null;
    }
);

export const getComparatorEfficientHouse = createSelector (
    energyEfficiencySelector,
    (state: IEnergyEfficiencyState) => state.comparatorEfficientHouse
);

export const getComparatorElectricMobility = createSelector (
    energyEfficiencySelector,
    (state: IEnergyEfficiencyState) => state.comparatorElectricMobility
);

